// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFlatMap<T extends {[key: string]: any}>(
    dataByKeys: Record<string, T[]>,
    key: string,
): Record<string, T> {
    const navigationItems: Record<string, T> = {};

    Object.values(dataByKeys).forEach((dataByKey) => {
        dataByKey.forEach((data: T) => {
            if (data[key]) {
                navigationItems[data[key]] = data;
            }
        });
    });

    return navigationItems;
}

export function getFlatList<T>(dataByKey: Record<string, T[]>, key = 'slug'): T[] {
    return Object.values(getFlatMap(dataByKey, key));
}
